import React from 'react';

const VideoDemo = () => {
  return (
    <section id="video" className="py-24 bg-[#101F27] relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#009688]/5 rounded-full blur-3xl"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <p className="text-base md:text-lg font-semibold text-[#009688] uppercase tracking-wide mb-4">
            See It In Action
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Watch{' '}
            <span className="text-white">
              WristCoin
            </span>{' '}
            Transform Operations
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            See how leading venues use WristCoin to boost sales and enhance guest experiences
          </p>
        </div>

        {/* Video Container */}
        <div className="relative max-w-5xl mx-auto">
          <div className="relative aspect-video rounded-2xl overflow-hidden shadow-2xl shadow-[#009688]/20 border border-[#009688]/30 bg-black">
            <iframe
              src="https://www.youtube-nocookie.com/embed/ArS6kLYmUTI?rel=0&modestbranding=1"
              title="What WristCoin Can Offer You"
              className="absolute inset-0 w-full h-full"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </div>

          {/* Decorative Elements */}
          <div className="absolute -top-4 -left-4 w-24 h-24 border-2 border-[#009688]/30 rounded-tl-3xl pointer-events-none"></div>
          <div className="absolute -bottom-4 -right-4 w-24 h-24 border-2 border-[#009688]/30 rounded-br-3xl pointer-events-none"></div>
        </div>
      </div>
    </section>
  );
};

export default VideoDemo;
